document.addEventListener('DOMContentLoaded', function(e) {
  initMenu();

  function initMenu() {
    const hamburger = document.querySelector('.gmenu-hamburger');
    const menuList = document.querySelector('.gmenu-list');
    const dropdowns = document.querySelectorAll('.has-dropdown');

    // SP用ハンバーガー開閉
    if (hamburger && menuList) {
      hamburger.addEventListener('click', function (e) {
        e.stopPropagation();
        hamburger.classList.toggle('is-active');
        menuList.classList.toggle('is-active');
      });
    }

    // 「兵庫編」「広島編」のタップ開閉と排他制御
    dropdowns.forEach(function (parentLi) {
      const toggleBtn = parentLi.querySelector('.dropdown-toggle');
      if (toggleBtn) {
        toggleBtn.addEventListener('click', function (e) {
          if (window.matchMedia('(hover: none)').matches || window.innerWidth <= 768) {
            e.preventDefault();
            e.stopPropagation();

            dropdowns.forEach(function (otherLi) {
              if (otherLi !== parentLi) {
                otherLi.classList.remove('is-open');
              }
            });

            parentLi.classList.toggle('is-open');
          }
        });
      }
    });

    // メニュー外をクリックした際にメニューを閉じる処理
    document.addEventListener('click', function (e) {
      if (menuList && !menuList.contains(e.target) && hamburger && !hamburger.contains(e.target)) {
        hamburger.classList.remove('is-active');
        menuList.classList.remove('is-active');
        dropdowns.forEach(function (li) {
          li.classList.remove('is-open');
        });
      }
    });
  }
});